import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";
import { GetCommunicationTypesDocument, type GetCommunicationTypesQuery } from "@/src/gql/graphql";

/**
 * Hook to fetch communication types for use in selects and filters
 */
export const useCommunicationTypes = () => {
  const { data, loading, error } = useQuery<GetCommunicationTypesQuery>(
    GetCommunicationTypesDocument,
    {
      errorPolicy: "all",
      notifyOnNetworkStatusChange: true,
    }
  );

  // Transform the data into options format - memoized to prevent recreation
  const options = useMemo(() => {
    return (
      data?.communication_typesCollection?.edges
        ?.map((edge: any) => edge?.node)
        .filter((node: any): node is NonNullable<typeof node> => node != null)
        .map((type: any) => ({
          label: type.label || type.key || "Unknown",
          value: type.id,
        })) || []
    );
  }, [data?.communication_typesCollection?.edges]);

  const fullData = useMemo(() => {
    return (
      data?.communication_typesCollection?.edges
        ?.map((edge: any) => edge?.node)
        .filter((node: any): node is NonNullable<typeof node> => node != null) || []
    );
  }, [data?.communication_typesCollection?.edges]);

  return {
    options,
    loading,
    error,
    data: fullData,
  };
};
